export default __webpack_public_path__ + "static/media/10_BeStrong.1ef1a173.jpg";